/**
 * GENERATED by scripts/site-rules/emit-snapshot.mjs — DO NOT EDIT.
 * Run `npm run site-rules:emit` after promoting groups in scripts/site-rules/overrides.json.
 * The shipped snapshot is the offline floor for matching; see
 * docs/superpowers/specs/2026-08-26-remote-site-rules-and-pmr-design.md §6.6.
 */
import type { SiteRulesBundle } from './siteRules';

/** The vetted equivalent-domain groups compiled into every client. */
export const SHIPPED_SITE_RULES: SiteRulesBundle = {
  "format": "heybesafe-site-rules",
  "version": 1,
  "generatedAt": "1970-01-01T00:00:00.000Z",
  "equivalentDomains": [
    {
      "group": [
        "a2hosting.com",
        "hosting.com"
      ],
      "vetted": true
    },
    {
      "group": [
        "activision.com",
        "callofduty.com"
      ],
      "vetted": true
    },
    {
      "group": [
        "airnewzealand.co.nz",
        "airnewzealand.com",
        "airnewzealand.com.au"
      ],
      "vetted": true
    },
    {
      "group": [
        "allure.com",
        "architecturaldigest.com",
        "bonappetit.com",
        "cntraveler.com",
        "condenast.com",
        "epicurious.com",
        "glamour.com",
        "gq.com",
        "newyorker.com",
        "pitchfork.com",
        "self.com",
        "teenvogue.com",
        "vanityfair.com",
        "vogue.com",
        "wired.com"
      ],
      "vetted": true
    },
    {
      "group": [
        "americastire.com",
        "discounttire.com"
      ],
      "vetted": true
    },
    {
      "group": [
        "angel.co",
        "wellfound.com"
      ],
      "vetted": true
    },
    {
      "group": [
        "appannie.com",
        "data.ai"
      ],
      "vetted": true
    },
    {
      "group": [
        "bark.co",
        "barkbox.com"
      ],
      "vetted": true
    },
    {
      "group": [
        "barrons.com",
        "dowjones.com",
        "marketwatch.com",
        "wsj.com"
      ],
      "vetted": true
    },
    {
      "group": [
        "bedbathandbeyond.com",
        "overstock.com"
      ],
      "vetted": true
    },
    {
      "group": [
        "bgg.cc",
        "boardgamegeek.com",
        "rpggeek.com",
        "videogamegeek.com"
      ],
      "vetted": true
    },
    {
      "group": [
        "bit.ly",
        "bitly.com"
      ],
      "vetted": true
    },
    {
      "group": [
        "blade.com",
        "flyblade.com"
      ],
      "vetted": true
    },
    {
      "group": [
        "bsky.app",
        "bsky.social"
      ],
      "vetted": true
    },
    {
      "group": [
        "centurylink.com",
        "lumen.com"
      ],
      "vetted": true
    },
    {
      "group": [
        "cleanshot.cloud",
        "cleanshot.com"
      ],
      "vetted": true
    },
    {
      "group": [
        "collecting.com",
        "collectingcars.com",
        "watchcollecting.com"
      ],
      "vetted": true
    },
    {
      "group": [
        "costco.ca",
        "costco.com"
      ],
      "vetted": true
    },
    {
      "group": [
        "dairyqueen.com",
        "dq.com"
      ],
      "vetted": true
    },
    {
      "group": [
        "dan.org",
        "diversalertnetwork.org"
      ],
      "vetted": true
    },
    {
      "group": [
        "deel.com",
        "letsdeel.com"
      ],
      "vetted": true
    },
    {
      "group": [
        "digi.ro",
        "digiromania.ro",
        "rcs-rds.ro"
      ],
      "vetted": true
    },
    {
      "group": [
        "discord.com",
        "discordapp.com"
      ],
      "vetted": true
    },
    {
      "group": [
        "discover.com",
        "discovercard.com"
      ],
      "vetted": true
    },
    {
      "group": [
        "e621.net",
        "e926.net"
      ],
      "vetted": true
    },
    {
      "group": [
        "eventbrite.at",
        "eventbrite.be",
        "eventbrite.ca",
        "eventbrite.ch",
        "eventbrite.cl",
        "eventbrite.co",
        "eventbrite.com",
        "eventbrite.de",
        "eventbrite.dk",
        "eventbrite.es",
        "eventbrite.fi",
        "eventbrite.fr",
        "eventbrite.hk",
        "eventbrite.ie",
        "eventbrite.in",
        "eventbrite.it",
        "eventbrite.my",
        "eventbrite.nl",
        "eventbrite.ph",
        "eventbrite.pt",
        "eventbrite.se",
        "eventbrite.sg"
      ],
      "vetted": true
    },
    {
      "group": [
        "express1040.com",
        "freetaxusa.com",
        "taxhawk.com"
      ],
      "vetted": true
    },
    {
      "group": [
        "flaglerclerk.com",
        "flaglerclerk.gov"
      ],
      "vetted": true
    },
    {
      "group": [
        "gamefaqs.com",
        "gamespot.com"
      ],
      "vetted": true
    },
    {
      "group": [
        "going.com",
        "scottscheapflights.com"
      ],
      "vetted": true
    },
    {
      "group": [
        "happen.com",
        "lendingclub.com"
      ],
      "vetted": true
    },
    {
      "group": [
        "hbomax.com",
        "max.com"
      ],
      "vetted": true
    },
    {
      "group": [
        "hejj.io",
        "skoophr.com"
      ],
      "vetted": true
    },
    {
      "group": [
        "infotechexpress.com",
        "workflowmanager.app"
      ],
      "vetted": true
    },
    {
      "group": [
        "keypointcu.com",
        "kpcu.com"
      ],
      "vetted": true
    },
    {
      "group": [
        "kodeco.com",
        "raywenderlich.com"
      ],
      "vetted": true
    },
    {
      "group": [
        "line.biz",
        "line.me"
      ],
      "vetted": true
    },
    {
      "group": [
        "lufthansa.com",
        "miles-and-more.com"
      ],
      "vetted": true
    },
    {
      "group": [
        "melio.com",
        "meliopayments.com"
      ],
      "vetted": true
    },
    {
      "group": [
        "mercadolivre.com",
        "mercadolivre.com.br",
        "mercadopago.com.br"
      ],
      "vetted": true
    },
    {
      "group": [
        "merrilledge.com",
        "ml.com"
      ],
      "vetted": true
    },
    {
      "group": [
        "mi.com",
        "xiaomi.com"
      ],
      "vetted": true
    },
    {
      "group": [
        "monarch.com",
        "monarchmoney.com"
      ],
      "vetted": true
    },
    {
      "group": [
        "moneybird.com",
        "moneybird.de",
        "moneybird.nl"
      ],
      "vetted": true
    },
    {
      "group": [
        "nebula.app",
        "nebula.tv",
        "watchnebula.com"
      ],
      "vetted": true
    },
    {
      "group": [
        "next.ink",
        "nextinpact.com"
      ],
      "vetted": true
    },
    {
      "group": [
        "npr.org",
        "publicmediasignin.org"
      ],
      "vetted": true
    },
    {
      "group": [
        "onsign.com",
        "onsign.tv"
      ],
      "vetted": true
    },
    {
      "group": [
        "optimum.com",
        "optimum.net"
      ],
      "vetted": true
    },
    {
      "group": [
        "parkmobile.io",
        "parkmobile.us"
      ],
      "vetted": true
    },
    {
      "group": [
        "peacock.com",
        "peacocktv.com"
      ],
      "vetted": true
    },
    {
      "group": [
        "proton.me",
        "protonmail.ch",
        "protonmail.com",
        "protonvpn.com"
      ],
      "vetted": true
    },
    {
      "group": [
        "quicken.com",
        "simplifimoney.com"
      ],
      "vetted": true
    },
    {
      "group": [
        "redis.com",
        "redislabs.com"
      ],
      "vetted": true
    },
    {
      "group": [
        "rtl.de",
        "rtlplus.com",
        "rtlplus.de",
        "tvnow.at",
        "tvnow.ch",
        "tvnow.de"
      ],
      "vetted": true
    },
    {
      "group": [
        "td.com",
        "tdbank.com"
      ],
      "vetted": true
    },
    {
      "group": [
        "telegram.me",
        "telegram.org"
      ],
      "vetted": true
    },
    {
      "group": [
        "ting.com",
        "tingmobile.com"
      ],
      "vetted": true
    },
    {
      "group": [
        "transferwise.com",
        "wise.com"
      ],
      "vetted": true
    },
    {
      "group": [
        "twitter.com",
        "x.com"
      ],
      "vetted": true
    },
    {
      "group": [
        "vistaprint.ca",
        "vistaprint.com"
      ],
      "vetted": true
    },
    {
      "group": [
        "ynab.com",
        "youneedabudget.com"
      ],
      "vetted": true
    }
  ],
  "sites": {
    "11st.co.kr": {
      "changePasswordUrl": "https://www.11st.co.kr/register/popupModifyPWD.tmall"
    },
    "1800contacts.com": {
      "changePasswordUrl": "https://www.1800contacts.com/account/settings"
    },
    "247sports.com": {
      "changePasswordUrl": "https://247sports.com/my/settings/password/"
    },
    "500px.com": {
      "changePasswordUrl": "https://web.500px.com/settings/account/security"
    },
    "a2hosting.com": {
      "changePasswordUrl": "https://my.hosting.com/profile/security"
    },
    "aa.com": {
      "changePasswordUrl": "https://www.aa.com/loyalty/profile/information"
    },
    "aarp.org": {
      "changePasswordUrl": "https://secure.aarp.org/account/editaccount?request_locale=en&nu=t"
    },
    "abc.es": {
      "changePasswordUrl": "https://areapersonal.abc.es/gestion/cambiar-contrasena.html"
    },
    "abc.net.au": {
      "changePasswordUrl": "https://account.abc.net.au/login-details"
    },
    "abcmouse.com": {
      "changePasswordUrl": "https://www.abcmouse.com/abc/parent-section"
    },
    "account.magento.com": {
      "changePasswordUrl": "https://account.magento.com/customer/account/changepassword"
    },
    "account.publishing.service.gov.uk": {
      "changePasswordUrl": "https://www.account.publishing.service.gov.uk/account/edit/password"
    },
    "accounts.panic.com": {
      "changePasswordUrl": "https://accounts.panic.com/password_set"
    },
    "accounts.pcid.ca": {
      "changePasswordUrl": "https://accounts.pcid.ca/forgot-password"
    },
    "acehardware.com": {
      "changePasswordUrl": "https://www.acehardware.com/myaccount#settings"
    },
    "acorns.com": {
      "changePasswordUrl": "https://app.acorns.com/settings/change-password"
    },
    "activision.com": {
      "changePasswordUrl": "https://s.activision.com/activision/profile"
    },
    "adafruit.com": {
      "changePasswordUrl": "https://accounts.adafruit.com/settings/password"
    },
    "adobe.com": {
      "changePasswordUrl": "https://account.adobe.com/security"
    },
    "adultfriendfinder.com": {
      "changePasswordUrl": "https://adultfriendfinder.com/p/update.cgi?p=my_account_update_account_password"
    },
    "adventhealth.com": {
      "changePasswordUrl": "https://account.adventhealth.com/manage-account"
    },
    "ae.com": {
      "changePasswordUrl": "https://www.ae.com/myaccount"
    },
    "aeon.co.jp": {
      "changePasswordUrl": "https://www.aeon.co.jp/app/settings/profile/password/"
    },
    "aerlingus.com": {
      "changePasswordUrl": "https://www.aerlingus.com/html/user-profile.html"
    },
    "aesop.com": {
      "changePasswordUrl": "https://www.aesop.com/my-account"
    },
    "aetna.com": {
      "changePasswordUrl": "https://health.aetna.com/preferences/account_security"
    },
    "agoda.com": {
      "changePasswordUrl": "https://www.agoda.com/account/profile.html"
    },
    "aircanada.com": {
      "changePasswordUrl": "https://www.aircanada.com/clogin/pages/change-password"
    },
    "airnewzealand.com": {
      "changePasswordUrl": "https://www.airnewzealand.com/membership/profile/security/password"
    },
    "alaskaair.com": {
      "changePasswordUrl": "https://www.alaskaair.com/www2/ssl/myalaskaair/myalaskaair.aspx?view=myinformation&tab=email"
    },
    "alibaba.com": {
      "changePasswordUrl": "https://i.alibaba.com/buyer/accounts/account_settings"
    },
    "aliexpress.com": {
      "changePasswordUrl": "https://login.aliexpress.com/"
    },
    "allegro.pl": {
      "changePasswordUrl": "https://allegro.pl/moje-allegro/moje-konto/logowanie-i-haslo"
    },
    "alliantcreditunion.com": {
      "changePasswordUrl": "https://www.alliantcreditunion.com/OnlineBanking/Settings/AccessAndSecurity/ChangePassword.aspx"
    },
    "allianz.com.br": {
      "changePasswordUrl": "https://www.allianz.com.br/alteracao-de-password-ecliente"
    },
    "allrecipes.com": {
      "changePasswordUrl": "https://www.allrecipes.com/account/profile#/change-password"
    },
    "allstate.com": {
      "changePasswordUrl": "https://myaccountrwd.allstate.com/secured/account/prospect-profile"
    },
    "alternate.de": {
      "changePasswordUrl": "https://www.alternate.de/html/myAccount/account/basicData.html"
    },
    "amazon.ae": {
      "changePasswordUrl": "https://www.amazon.ae/ax/account/manage"
    },
    "amazon.ca": {
      "changePasswordUrl": "https://www.amazon.ca/ax/account/manage"
    },
    "amazon.co.jp": {
      "changePasswordUrl": "https://www.amazon.co.jp/ax/account/manage"
    },
    "amazon.co.uk": {
      "changePasswordUrl": "https://www.amazon.co.uk/ax/account/manage"
    },
    "amazon.com": {
      "changePasswordUrl": "https://www.amazon.com/ax/account/manage"
    },
    "amazon.com.au": {
      "changePasswordUrl": "https://www.amazon.com.au/ax/account/manage"
    },
    "amazon.com.br": {
      "changePasswordUrl": "https://www.amazon.com.br/ax/account/manage"
    },
    "amazon.com.mx": {
      "changePasswordUrl": "https://www.amazon.com.mx/ax/account/manage"
    },
    "amazon.com.tr": {
      "changePasswordUrl": "https://www.amazon.com.tr/ax/account/manage"
    },
    "amazon.de": {
      "changePasswordUrl": "https://www.amazon.de/ax/account/manage"
    },
    "amazon.es": {
      "changePasswordUrl": "https://www.amazon.es/ax/account/manage"
    },
    "amazon.fr": {
      "changePasswordUrl": "https://www.amazon.fr/ax/account/manage"
    },
    "amazon.in": {
      "changePasswordUrl": "https://www.amazon.in/ax/account/manage"
    },
    "amazon.it": {
      "changePasswordUrl": "https://www.amazon.it/ax/account/manage"
    },
    "amazon.nl": {
      "changePasswordUrl": "https://www.amazon.nl/ax/account/manage"
    },
    "amazon.pl": {
      "changePasswordUrl": "https://www.amazon.pl/ax/account/manage"
    },
    "amazon.sa": {
      "changePasswordUrl": "https://www.amazon.sa/ax/account/manage"
    },
    "amazon.se": {
      "changePasswordUrl": "https://www.amazon.se/ax/account/manage"
    },
    "amazon.sg": {
      "changePasswordUrl": "https://www.amazon.sg/ax/account/manage"
    },
    "amazonaws.com": {
      "changePasswordUrl": "https://console.aws.amazon.com/iam/home#/security_credentials"
    },
    "amctheatres.com": {
      "changePasswordUrl": "https://www.amctheatres.com/amcstubs/account"
    },
    "americanexpress.com": {
      "changePasswordUrl": "https://www.americanexpress.com/en-us/account/password/manage"
    },
    "amtrak.com": {
      "changePasswordUrl": "https://www.amtrak.com/guestrewards/account-overview/profile"
    },
    "ana.co.jp": {
      "changePasswordUrl": "https://cam.ana.co.jp/psz/us/amc_us.jsp?index=105"
    },
    "anatel.gov.br": {
      "changePasswordUrl": "https://apps.anatel.gov.br/AnatelConsumidor/ConsumidorEditar.aspx"
    },
    "ancestry.com": {
      "changePasswordUrl": "https://www.ancestry.com/account/security/password"
    },
    "aol.com": {
      "changePasswordUrl": "https://login.aol.com/account/change-password"
    },
    "apartments.com": {
      "changePasswordUrl": "https://www.apartments.com/my-account/#"
    },
    "app.link": {
      "changePasswordUrl": "https://dashboard.branch.io/account-settings/user"
    },
    "app.parkmobile.io": {
      "changePasswordUrl": "https://app.parkmobile.io/account/settings"
    },
    "apple.com": {
      "changePasswordUrl": "https://appleid.apple.com/account/manage"
    },
    "archive.org": {
      "changePasswordUrl": "https://archive.org/account/index.php?settings=1"
    },
    "argos.co.uk": {
      "changePasswordUrl": "https://www.argos.co.uk/my-account/security-settings"
    },
    "arlt.com": {
      "changePasswordUrl": "https://www.arlt.com/mein-passwort/"
    },
    "arstechnica.com": {
      "changePasswordUrl": "https://arstechnica.com/civis/account/security"
    },
    "arxiv.org": {
      "changePasswordUrl": "https://arxiv.org/user/change_own_password"
    },
    "asda.com": {
      "changePasswordUrl": "https://www.asda.com/account"
    },
    "astonmartinf1.com": {
      "changePasswordUrl": "https://auth.astonmartinf1.com/Dashboard/ChangePassword"
    },
    "atlassian.com": {
      "changePasswordUrl": "https://id.atlassian.com/manage-profile/security"
    },
    "atlassian.net": {
      "changePasswordUrl": "https://id.atlassian.com/manage-profile/security"
    },
    "att.com": {
      "changePasswordUrl": "https://www.att.com/acctmgmt/profile/overview"
    },
    "att.net": {
      "changePasswordUrl": "https://www.att.com/acctmgmt/profile/overview"
    },
    "attn.tv": {
      "changePasswordUrl": "https://ui.attentivemobile.com/forgot-password"
    },
    "auction.co.kr": {
      "changePasswordUrl": "https://memberssl.auction.co.kr/membership/MyInfo/MyInfo.aspx"
    },
    "auctionzip.com": {
      "changePasswordUrl": "https://www.auctionzip.com/cgi-bin/userpanel.cgi?mode=3"
    },
    "autodesk.com": {
      "changePasswordUrl": "https://accounts.autodesk.com/Profile/Security"
    },
    "autotrader.com": {
      "changePasswordUrl": "https://www.autotrader.com/account/profile"
    },
    "b2c.voegol.com.br": {
      "changePasswordUrl": "https://b2c.voegol.com.br/minhas-viagens/meu-perfil"
    },
    "bahn.de": {
      "changePasswordUrl": "https://accounts.bahn.de/auth/realms/db/account/password"
    },
    "bamboohr.com": {
      "changePasswordUrl": "https://employeewe.bamboohr.com/dashboard/password.php"
    },
    "bancochile.cl": {
      "changePasswordUrl": "https://portalpersonas.bancochile.cl/mibancochile-web/front/persona/index.html#/mi-perfil/datos-seguridad"
    },
    "bandcamp.com": {
      "changePasswordUrl": "https://bandcamp.com/settings#password"
    },
    "bankofamerica.com": {
      "changePasswordUrl": "https://secure.bankofamerica.com/auth/security-center/main/?activity=changePasscode"
    },
    "barnesandnoble.com": {
      "changePasswordUrl": "https://www.barnesandnoble.com/account/manage/settings/"
    },
    "bathandbodyworks.com": {
      "changePasswordUrl": "https://www.bathandbodyworks.com/my-account/edit-profile"
    },
    "battle.net": {
      "changePasswordUrl": "https://account.battle.net/security"
    },
    "bayareafastrak.org": {
      "changePasswordUrl": "https://www.bayareafastrak.org/vector/account/home/ftAccountSettings.do"
    },
    "bbq-grill-world.de": {
      "changePasswordUrl": "https://www.bbq-grill-world.de/customer/account/edit/changepass/1/"
    },
    "bedbathandbeyond.com": {
      "changePasswordUrl": "https://www.bedbathandbeyond.com/store/account/personalinfo"
    },
    "belk.com": {
      "changePasswordUrl": "https://www.belk.com/account-edit-profile/"
    },
    "benefitslogin.discoverybenefits.com": {
      "changePasswordUrl": "https://benefitslogin.discoverybenefits.com/Profile/UpdatePassword.aspx"
    },
    "berlet.de": {
      "changePasswordUrl": "https://www.berlet.de/mein-konto.htm#my-account--edit-pass"
    },
    "bestbuy.com": {
      "changePasswordUrl": "https://www.bestbuy.com/identity/accountSettings/page/password"
    },
    "biblegateway.com": {
      "changePasswordUrl": "https://www.biblegateway.com/user/account/"
    },
    "bild.de": {
      "changePasswordUrl": "https://signin.auth.bild.de/change-password"
    },
    "bing.com": {
      "changePasswordUrl": "https://account.live.com/password/Change"
    },
    "birkenstock.com": {
      "changePasswordUrl": "https://www.birkenstock.com/profile"
    },
    "bit.ly": {
      "changePasswordUrl": "https://app.bitly.com/settings/profile"
    },
    "blackbaud.com": {
      "changePasswordUrl": "https://app.blackbaud.com/user/"
    },
    "blackwells.co.uk": {
      "changePasswordUrl": "https://blackwells.co.uk/bookshop/account/personal-details"
    },
    "blend.io": {
      "changePasswordUrl": "https://blend.io/settings"
    },
    "blockchain.com": {
      "changePasswordUrl": "https://login.blockchain.com/en/#/security-center/advanced"
    },
    "blooket.com": {
      "changePasswordUrl": "https://id.blooket.com/forgot"
    },
    "bloomberg.com": {
      "changePasswordUrl": "https://www.bloomberg.com/portal/account"
    },
    "bloomingdales.com": {
      "changePasswordUrl": "https://www.bloomingdales.com/account/profile"
    },
    "blutdruck-shop.de": {
      "changePasswordUrl": "https://www.blutdruck-shop.de/mein-passwort/"
    },
    "booking.com": {
      "changePasswordUrl": "https://account.booking.com/account-recovery"
    },
    "boredpanda.com": {
      "changePasswordUrl": "https://www.boredpanda.com/settings/"
    },
    "borrowell.com": {
      "changePasswordUrl": "https://app.borrowell.com/#/app/changePassword"
    },
    "box.com": {
      "changePasswordUrl": "https://app.box.com/account"
    },
    "browserstack.com": {
      "changePasswordUrl": "https://www.browserstack.com/accounts/profile"
    },
    "bsky.app": {
      "changePasswordUrl": "https://bsky.app/settings/account"
    },
    "bugzilla.kernel.org": {
      "changePasswordUrl": "https://bugzilla.kernel.org/userprefs.cgi?tab=account"
    },
    "businessinsider.com": {
      "changePasswordUrl": "https://www.businessinsider.com/#"
    },
    "buzzfeed.com": {
      "changePasswordUrl": "https://www.buzzfeed.com/settings/password/change"
    },
    "cakeresume.com": {
      "changePasswordUrl": "https://www.cakeresume.com/settings/account?ref=navs_settings"
    },
    "calculator.net": {
      "changePasswordUrl": "https://www.calculator.net/my-account/"
    },
    "callofduty.com": {
      "changePasswordUrl": "https://profile.callofduty.com/cod/info"
    },
    "candyrect.com": {
      "changePasswordUrl": "https://user.candyrect.com/helpcenter/"
    },
    "canva.com": {
      "changePasswordUrl": "https://www.canva.com/login?redirect=%2Fsettings%2Flogin-and-security"
    },
    "capitalone.com": {
      "changePasswordUrl": "https://myaccounts.capitalone.com/Security/changePassword"
    },
    "cargurus.com": {
      "changePasswordUrl": "https://www.cargurus.com/Cars/myAccount/accountSettings"
    },
    "carmax.com": {
      "changePasswordUrl": "https://www.carmax.com/myaccount/login/svc/oidc/password/change"
    },
    "carnival.com": {
      "changePasswordUrl": "https://www.carnival.com/profilemanagement/profiles/changepassword"
    },
    "cars.com": {
      "changePasswordUrl": "https://www.cars.com/reset_password"
    },
    "carta.com": {
      "changePasswordUrl": "https://app.carta.com/profiles/update/"
    },
    "carvana.com": {
      "changePasswordUrl": "https://www.carvana.com/account-ui/personal-details/edit-password"
    },
    "cbsnews.com": {
      "changePasswordUrl": "https://www.cbsnews.com/user/change-password/"
    },
    "cbssports.com": {
      "changePasswordUrl": "https://www.cbssports.com/settings/account"
    },
    "cdiscount.com": {
      "changePasswordUrl": "https://clients.cdiscount.com/account/customer/accountparameters.html?tab=parameter"
    },
    "cecredentialtrust.com": {
      "changePasswordUrl": "https://secure.cecredentialtrust.com/account/editpassword/"
    },
    "celebrations.com": {
      "changePasswordUrl": "https://www.celebrations.com/z/account/profile"
    },
    "censys.io": {
      "changePasswordUrl": "https://censys.io/account"
    },
    "change.org": {
      "changePasswordUrl": "https://www.change.org/account_settings/change_password"
    },
    "chapmanganato.com": {
      "changePasswordUrl": "https://user.manganelo.com/user_changes_pass"
    },
    "chase.com": {
      "changePasswordUrl": "https://secure07ea.chase.com/web/auth/dashboard#/dashboard/myProfileSignInSecurity/resetPassword/resetPassword"
    },
    "chaturbate.com": {
      "changePasswordUrl": "https://chaturbate.com/auth/password_change/"
    },
    "chegg.com": {
      "changePasswordUrl": "https://www.chegg.com/my/account-next"
    },
    "chess.com": {
      "changePasswordUrl": "https://www.chess.com/settings/password"
    },
    "chewy.com": {
      "changePasswordUrl": "https://www.chewy.com/app/resetpassword"
    },
    "churchofjesuschrist.org": {
      "changePasswordUrl": "https://account.churchofjesuschrist.org/changePassword"
    },
    "cinemark.com.br": {
      "changePasswordUrl": "https://www.cinemark.com.br/minha-conta"
    },
    "citi.com": {
      "changePasswordUrl": "https://online.citi.com/US/ag/profile-update/change-password"
    },
    "claro.com.br": {
      "changePasswordUrl": "https://minhanet.net.com.br/webcenter/portal/MinhaNet/pages_alterarsenha"
    },
    "clevelandclinic.org": {
      "changePasswordUrl": "https://mychart.clevelandclinic.org/inside.asp?mode=passwd"
    },
    "clien.net": {
      "changePasswordUrl": "https://www.clien.net/service/mypage/myInfoComfrim"
    },
    "cloudflare.com": {
      "changePasswordUrl": "https://dash.cloudflare.com/profile/authentication"
    },
    "cnbc.com": {
      "changePasswordUrl": "https://www.cnbc.com/account/#profile"
    },
    "cnn.com": {
      "changePasswordUrl": "https://www.cnn.com/account/settings"
    },
    "codepen.io": {
      "changePasswordUrl": "https://codepen.io/settings/account"
    },
    "coinbase.com": {
      "changePasswordUrl": "https://accounts.coinbase.com/security"
    },
    "collegeboard.org": {
      "changePasswordUrl": "https://my.collegeboard.org/profile/information"
    },
    "columbia.com": {
      "changePasswordUrl": "https://www.columbia.com/profile"
    },
    "comcast.com": {
      "changePasswordUrl": "https://customer.xfinity.com/users/me/update-password"
    },
    "comcast.net": {
      "changePasswordUrl": "https://customer.xfinity.com/users/me/update-password"
    },
    "constantcontact.com": {
      "changePasswordUrl": "https://app.constantcontact.com/pages/myaccount/settings/account"
    },
    "consumidor.gov.br": {
      "changePasswordUrl": "https://www.consumidor.gov.br/pages/usuario/editar"
    },
    "costco.ca": {
      "changePasswordUrl": "https://www.costco.ca/ChangePassword"
    },
    "costco.com": {
      "changePasswordUrl": "https://www.costco.com/AccountInformationView?identifier=manage-membership"
    },
    "coupang.com": {
      "changePasswordUrl": "https://login.coupang.com/login/userModify.pang"
    },
    "coursehero.com": {
      "changePasswordUrl": "https://www.coursehero.com/my-account/#/settings"
    },
    "cpanel.com": {
      "changePasswordUrl": "https://store.cpanel.net/my/password"
    },
    "cpanel.net": {
      "changePasswordUrl": "https://store.cpanel.net/my/password"
    },
    "crackle.com": {
      "changePasswordUrl": "https://www.crackle.com/profile"
    },
    "craigslist.org": {
      "changePasswordUrl": "https://accounts.craigslist.org"
    },
    "creditkarma.com": {
      "changePasswordUrl": "https://www.creditkarma.com/profile/security/change-password"
    },
    "credly.com": {
      "changePasswordUrl": "https://www.credly.com/earner/settings/privacy"
    },
    "crowdin.com": {
      "changePasswordUrl": "https://accounts.crowdin.com/password/change"
    },
    "crunchyroll.com": {
      "changePasswordUrl": "https://www.crunchyroll.com/resetpw"
    },
    "cvs.com": {
      "changePasswordUrl": "https://www.cvs.com/my-account/profile/sign-in-and-security/edit-password"
    },
    "dafont.com": {
      "changePasswordUrl": "https://www.dafont.com/member_password.php"
    },
    "dailymail.co.uk": {
      "changePasswordUrl": "https://www.dailymail.co.uk/registration/profile/change-password.html"
    },
    "dailymotion.com": {
      "changePasswordUrl": "https://www.dailymotion.com/partner/account/password"
    },
    "dan.com": {
      "changePasswordUrl": "https://dan.com/users/settings/account"
    },
    "danawa.com": {
      "changePasswordUrl": "https://auth.danawa.com/modifyMember"
    },
    "darty.com": {
      "changePasswordUrl": "https://www.darty.com/espace_client/donnees-personnelles/mot-de-passe/edition"
    },
    "daum.net": {
      "changePasswordUrl": "https://member.daum.net/change/password.daum"
    },
    "deere.com": {
      "changePasswordUrl": "https://account.deere.com/actmgmt/change-password"
    },
    "dell.com": {
      "changePasswordUrl": "https://www.dell.com/dci/idp/dwa/editSecuritySetting"
    },
    "delta.com": {
      "changePasswordUrl": "https://www.delta.com/myprofile/security-settings"
    },
    "deviantart.com": {
      "changePasswordUrl": "https://www.deviantart.com/settings/general"
    },
    "dickssportinggoods.com": {
      "changePasswordUrl": "https://www.dickssportinggoods.com/MyAccount/AccountSettings"
    },
    "digitalocean.com": {
      "changePasswordUrl": "https://cloud.digitalocean.com/settings/security"
    },
    "discogs.com": {
      "changePasswordUrl": "https://www.discogs.com/settings/user"
    },
    "discord.com": {
      "changePasswordUrl": "https://discord.com/settings/account"
    },
    "discover.com": {
      "changePasswordUrl": "https://card.discover.com/cardmembersvcs/personalprofile/pp/UpdateDetails?ICMPGN=MYPROFILE_USERID_PASSWORD_TXT"
    },
    "disneyplus.com": {
      "changePasswordUrl": "https://my.disney.com/edit/password"
    },
    "dittomusic.com": {
      "changePasswordUrl": "https://dashboard.dittomusic.com/account/password"
    },
    "dmm.co.jp": {
      "changePasswordUrl": "https://accounts.dmm.co.jp/settings/change/password"
    },
    "dmm.com": {
      "changePasswordUrl": "https://accounts.dmm.com/settings/password"
    },
    "doctolib.fr": {
      "changePasswordUrl": "https://www.doctolib.fr/account/edit"
    },
    "doctoralia.com.br": {
      "changePasswordUrl": "https://l.doctoralia.com.br/change-password"
    },
    "docusign.com": {
      "changePasswordUrl": "https://account.docusign.com/me/changepassword"
    },
    "docusign.net": {
      "changePasswordUrl": "https://account.docusign.com/me/changepassword"
    },
    "dominos.com": {
      "changePasswordUrl": "https://www.dominos.com/en/pages/customer/#!/customer/settings/"
    },
    "doordash.com": {
      "changePasswordUrl": "https://www.doordash.com/accounts/password/reset/"
    },
    "dotloop.com": {
      "changePasswordUrl": "https://www.dotloop.com/my/account/#/settings"
    },
    "dropbox.com": {
      "changePasswordUrl": "https://www.dropbox.com/account/security"
    },
    "dsw.com": {
      "changePasswordUrl": "https://www.dsw.com/en/us/profile"
    },
    "duolingo.com": {
      "changePasswordUrl": "https://duolingo.com/settings/profile"
    },
    "dwr.com": {
      "changePasswordUrl": "https://www.dwr.com/profile"
    },
    "ea.com": {
      "changePasswordUrl": "https://myaccount.ea.com/cp-ui/security/index"
    },
    "ebay.co.uk": {
      "changePasswordUrl": "https://accounts.ebay.co.uk/acctsec/security-center"
    },
    "ebay.com": {
      "changePasswordUrl": "https://accounts.ebay.com/acctsec/security-center/chngpwd"
    },
    "eki-net.com": {
      "changePasswordUrl": "https://id.jreast.co.jp/idcs/contents/menu/pwd_change"
    },
    "elcorteingles.es": {
      "changePasswordUrl": "https://cuenta.elcorteingles.es/perfil/acceso/"
    },
    "elmundo.es": {
      "changePasswordUrl": "https://www.elmundo.es/micuenta/v1/es/user-area/account"
    },
    "elpais.com": {
      "changePasswordUrl": "https://elpais.com/subscriptions/#/profile"
    },
    "epicgames.com": {
      "changePasswordUrl": "https://www.epicgames.com/account/password"
    },
    "eporner.com": {
      "changePasswordUrl": "https://www.eporner.com/profile/mturk_eporn/my/edit-pass/"
    },
    "espn.com": {
      "changePasswordUrl": "https://my.disney.com/edit/password"
    },
    "etrade.com": {
      "changePasswordUrl": "https://us.etrade.com/etx/pxy/security-settings/change-password/page"
    },
    "etsy.com": {
      "changePasswordUrl": "https://www.etsy.com/your/account"
    },
    "eventbrite.com": {
      "changePasswordUrl": "https://www.eventbrite.com/account-settings/password"
    },
    "evite.com": {
      "changePasswordUrl": "https://www.evite.com/settings/password"
    },
    "expedia.com": {
      "changePasswordUrl": "https://www.expedia.com/account/settings"
    },
    "experian.com": {
      "changePasswordUrl": "https://usa.experian.com/member/ngx-profile/account-info"
    },
    "facebook.com": {
      "changePasswordUrl": "https://accountscenter.facebook.com/password_and_security/password/change"
    },
    "familysearch.org": {
      "changePasswordUrl": "https://www.familysearch.org/identity/settings/account"
    },
    "fandango.com": {
      "changePasswordUrl": "https://www.fandango.com/accounts/settings"
    },
    "fandom.com": {
      "changePasswordUrl": "https://auth.fandom.com/auth/settings"
    },
    "fanfiction.net": {
      "changePasswordUrl": "https://www.fanfiction.net/account/password.php"
    },
    "fc2.com": {
      "changePasswordUrl": "https://secure.id.fc2.com/edit.php"
    },
    "fedex.com": {
      "changePasswordUrl": "https://www.fedex.com/profile/en-us/#/login"
    },
    "fetlife.com": {
      "changePasswordUrl": "https://fetlife.com/settings/account/password"
    },
    "fidelity.com": {
      "changePasswordUrl": "https://fps.fidelity.com/ftgw/Fps/Fidelity/RtlCust/ChangePIN/Init"
    },
    "finance.yahoo.com": {
      "changePasswordUrl": "https://login.yahoo.com/myaccount/security/change-password/?src=finance"
    },
    "findagrave.com": {
      "changePasswordUrl": "https://www.findagrave.com/user/account/password"
    },
    "fitbit.com": {
      "changePasswordUrl": "https://www.fitbit.com/settings/profile"
    },
    "flightaware.com": {
      "changePasswordUrl": "https://flightaware.com/account/manage"
    },
    "fnac.com": {
      "changePasswordUrl": "https://secure.fnac.com/account/update-password"
    },
    "foodnetwork.com": {
      "changePasswordUrl": "https://www.foodnetwork.com/user-profile-page"
    },
    "forbes.com": {
      "changePasswordUrl": "https://account.forbes.com/profile"
    },
    "force.com": {
      "changePasswordUrl": "https://na224.lightning.force.com/lightning/settings/personal/ChangePassword/home"
    },
    "foursquare.com": {
      "changePasswordUrl": "https://foursquare.com/change_password"
    },
    "foxbusiness.com": {
      "changePasswordUrl": "https://my.foxbusiness.com/?p=account"
    },
    "foxnews.com": {
      "changePasswordUrl": "https://my.foxnews.com/?pieces=reset"
    },
    "foxsports.com": {
      "changePasswordUrl": "https://www.foxsports.com/#"
    },
    "frutifica.com.br": {
      "changePasswordUrl": "https://www.frutifica.com.br/conta/alterar_senha"
    },
    "gamefaqs.gamespot.com": {
      "changePasswordUrl": "https://gamefaqs.gamespot.com/user/mailpass"
    },
    "gamespot.com": {
      "changePasswordUrl": "https://www.gamespot.com/change-details/"
    },
    "gap.com": {
      "changePasswordUrl": "https://secure-www.gap.com/my-account/change-password"
    },
    "gazetadopovo.com.br": {
      "changePasswordUrl": "https://conta.gazetadopovo.com.br/minha-conta/meus-dados"
    },
    "genius.com": {
      "changePasswordUrl": "https://genius.com/password_resets/new"
    },
    "geocaching.com": {
      "changePasswordUrl": "https://www.geocaching.com/account/settings/changepassword"
    },
    "getflywheel.com": {
      "changePasswordUrl": "https://app.getflywheel.com/profile/security/change_password"
    },
    "girlscouts.org": {
      "changePasswordUrl": "https://mygs.girlscouts.org/my-account/account"
    },
    "github.com": {
      "changePasswordUrl": "https://github.com/settings/security"
    },
    "glassdoor.com": {
      "changePasswordUrl": "https://www.glassdoor.com/member/profile/settings.htm"
    },
    "globo.com": {
      "changePasswordUrl": "https://minhaconta-v2.globo.com/#/alterar-senha"
    },
    "gm.com": {
      "changePasswordUrl": "https://experience.gm.com/myaccount/security/passwordChange"
    },
    "gmail.com": {
      "changePasswordUrl": "https://myaccount.google.com/signinoptions/password?continue=https://myaccount.google.com/security"
    },
    "gmarket.co.kr": {
      "changePasswordUrl": "https://sslmember2.gmarket.co.kr/MYInfo/MemberInfo"
    },
    "gmx.net": {
      "changePasswordUrl": "https://account.gmx.net/ciss/security/edit/passwordChange"
    },
    "go.com": {
      "changePasswordUrl": "https://my.disney.com/edit/password"
    },
    "gocomics.com": {
      "changePasswordUrl": "https://www.gocomics.com/profiles/create-password"
    },
    "godaddy.com": {
      "changePasswordUrl": "https://sso.godaddy.com/security/password"
    },
    "gog.com": {
      "changePasswordUrl": "https://www.gog.com/account/settings/security"
    },
    "goodhousekeeping.com": {
      "changePasswordUrl": "https://www.mylo.id/account"
    },
    "goodreads.com": {
      "changePasswordUrl": "https://www.goodreads.com/user/edit?tab=settings"
    },
    "google.com": {
      "changePasswordUrl": "https://myaccount.google.com/signinoptions/password"
    },
    "gotchamall.com": {
      "changePasswordUrl": "https://jp.gotchamall.com/user/password/update"
    },
    "gov.br": {
      "changePasswordUrl": "https://acesso.gov.br/area-cidadao/#/alterarSenha"
    },
    "grainger.com": {
      "changePasswordUrl": "https://www.grainger.com/myaccount/loginoptions"
    },
    "grubhub.com": {
      "changePasswordUrl": "https://www.grubhub.com/account/profile"
    },
    "happycow.net": {
      "changePasswordUrl": "https://www.happycow.net/members/profile/update/password"
    },
    "hbomax.com": {
      "changePasswordUrl": "https://auth.hbomax.com/account/edit/password"
    },
    "healthsafe-id.com": {
      "changePasswordUrl": "https://www.healthsafe-id.com/rt/secure/settings/hsid/"
    },
    "heroku.com": {
      "changePasswordUrl": "https://dashboard.heroku.com/account"
    },
    "hibrain.net": {
      "changePasswordUrl": "https://hibrain.net/mybrain/users/password/edit"
    },
    "hilton.com": {
      "changePasswordUrl": "https://www.hilton.com/en/hilton-honors/guest/profile/personal-information/"
    },
    "homedepot.com": {
      "changePasswordUrl": "https://www.homedepot.com/myaccount/security"
    },
    "homes.com": {
      "changePasswordUrl": "https://www.homes.com/auth/changepassword/"
    },
    "honeywell.com": {
      "changePasswordUrl": "https://honeywell.csod.com/resetPasswrd.aspx?"
    },
    "hosting.com": {
      "changePasswordUrl": "https://my.hosting.com/profile/security"
    },
    "hotels.com": {
      "changePasswordUrl": "https://www.hotels.com/login?redirectTo=%2Faccount%2Fsettings"
    },
    "hotmart.com": {
      "changePasswordUrl": "https://account.hotmart.com/security-privacy"
    },
    "housecallpro.com": {
      "changePasswordUrl": "https://pro.housecallpro.com/service_pro/account/reset_password"
    },
    "hp.com": {
      "changePasswordUrl": "https://account.id.hp.com/security"
    },
    "hsn.com": {
      "changePasswordUrl": "https://www.hsn.com/myaccount/update"
    },
    "huffpost.com": {
      "changePasswordUrl": "https://www.huffpost.com/member/edit-profile"
    },
    "hulu.com": {
      "changePasswordUrl": "https://my.disney.com/edit/password"
    },
    "icloud.com": {
      "changePasswordUrl": "https://appleid.apple.com/account/manage"
    },
    "id.me": {
      "changePasswordUrl": "https://account.id.me/signin/password"
    },
    "idealista.com": {
      "changePasswordUrl": "https://www.idealista.com/usuario/tus-datos/acceso"
    },
    "idealo.de": {
      "changePasswordUrl": "https://account.idealo.de/settings"
    },
    "ign.com": {
      "changePasswordUrl": "https://www.ign.com/account/security"
    },
    "iherb.com": {
      "changePasswordUrl": "https://checkout.iherb.com/users/account-info/edit-password"
    },
    "ihg.com": {
      "changePasswordUrl": "https://www.ihg.com/rewardsclub/gb/en/account-mgmt/personalInformation"
    },
    "ilovepdf.com": {
      "changePasswordUrl": "https://www.ilovepdf.com/user/security"
    },
    "imgur.com": {
      "changePasswordUrl": "https://imgur.com/account/settings/password"
    },
    "immobilienscout24.de": {
      "changePasswordUrl": "https://sso.immobilienscout24.de/account/verwaltung"
    },
    "impots.gouv.fr": {
      "changePasswordUrl": "https://cfspart.impots.gouv.fr/monprofil-webapp/GererMonProfil"
    },
    "indeed.com": {
      "changePasswordUrl": "https://secure.indeed.com/account/changepassword"
    },
    "independent.co.uk": {
      "changePasswordUrl": "https://www.independent.co.uk/profile"
    },
    "insider.com": {
      "changePasswordUrl": "https://www.insider.com/"
    },
    "instacart.com": {
      "changePasswordUrl": "https://www.instacart.com/store/account"
    },
    "instagram.com": {
      "changePasswordUrl": "https://accountscenter.instagram.com/password_and_security/password/change/"
    },
    "intuit.com": {
      "changePasswordUrl": "https://accounts.intuit.com/app/account-manager/security/password"
    },
    "iq.com": {
      "changePasswordUrl": "https://www.iq.com/personal?type=settings"
    },
    "istockphoto.com": {
      "changePasswordUrl": "https://www.istockphoto.com/change-password"
    },
    "itv.com": {
      "changePasswordUrl": "https://www.itv.com/watch/user/password/update"
    },
    "jalan.net": {
      "changePasswordUrl": "https://www.jalan.net/uw/uwp8000/uww8010.do"
    },
    "jcpenney.com": {
      "changePasswordUrl": "https://www.jcpenney.com/account/dashboard/personal/info"
    },
    "jimdofree.com": {
      "changePasswordUrl": "https://dash.e.jimdo.com/profile"
    },
    "jw.org": {
      "changePasswordUrl": "https://apps.jw.org/E_PASSCHG1"
    },
    "kahoot.it": {
      "changePasswordUrl": "https://create.kahoot.it/user/change-password"
    },
    "kaiserpermanente.org": {
      "changePasswordUrl": "https://healthy.kaiserpermanente.org/mychartcn/Extensibility/Redirection/FdiRedirection?option=profile"
    },
    "kakao.com": {
      "changePasswordUrl": "https://accounts.kakao.com/weblogin/account/security/change_password"
    },
    "kbb.com": {
      "changePasswordUrl": "https://www.kbb.com/account/profile"
    },
    "key.harvard.edu": {
      "changePasswordUrl": "https://key.harvard.edu/manage-account/change-password"
    },
    "kickstarter.com": {
      "changePasswordUrl": "https://www.kickstarter.com/settings/account"
    },
    "klook.com": {
      "changePasswordUrl": "https://www.klook.com/account_setting/"
    },
    "kohls.com": {
      "changePasswordUrl": "https://www.kohls.com/myaccount/settings/information"
    },
    "kroger.com": {
      "changePasswordUrl": "https://www.kroger.com/account/update"
    },
    "kundenportal.edeka-smart.de": {
      "changePasswordUrl": "https://kundenportal.edeka-smart.de/edeka-csc/forgot-password"
    },
    "landsend.com": {
      "changePasswordUrl": "https://www.landsend.com/co/account/settings"
    },
    "larazon.es": {
      "changePasswordUrl": "https://www.larazon.es/usuario/modificar-contrasena"
    },
    "latimes.com": {
      "changePasswordUrl": "https://membership.latimes.com/settings"
    },
    "leetcode.com": {
      "changePasswordUrl": "https://leetcode.com/accounts/password/set/"
    },
    "legacy.com": {
      "changePasswordUrl": "https://legacy.memoriams.com/Network/Account/ChangePassword"
    },
    "lego.com": {
      "changePasswordUrl": "https://my.lego.com/security/change-password"
    },
    "lemonde.fr": {
      "changePasswordUrl": "https://moncompte.lemonde.fr/gcustomer/account/password"
    },
    "letterboxd.com": {
      "changePasswordUrl": "https://letterboxd.com/settings/auth/"
    },
    "linkedin.com": {
      "changePasswordUrl": "https://www.linkedin.com/psettings/change-password"
    },
    "linktr.ee": {
      "changePasswordUrl": "https://linktr.ee/admin/account"
    },
    "linode.com": {
      "changePasswordUrl": "https://cloud.linode.com/profile/auth"
    },
    "live.com": {
      "changePasswordUrl": "https://account.live.com/password/change?refd=account.microsoft.com&fref=home.banner.changepwd"
    },
    "livejasmin.com": {
      "changePasswordUrl": "https://www.livejasmin.com/en/girls/#!settings/account"
    },
    "llbean.com": {
      "changePasswordUrl": "https://www.llbean.com/account/password"
    },
    "login.gov": {
      "changePasswordUrl": "https://secure.login.gov/manage/password"
    },
    "lowes.com": {
      "changePasswordUrl": "https://www.lowes.com/security/settings"
    },
    "lu.ma": {
      "changePasswordUrl": "https://lu.ma/settings"
    },
    "macys.com": {
      "changePasswordUrl": "https://www.macys.com/account/profile?cm_sp=macys_account-_-my_account-_-my_profile&linklocation=leftrail"
    },
    "marca.com": {
      "changePasswordUrl": "https://www.marca.com/micuenta/v1/user-area/account"
    },
    "marketwatch.com": {
      "changePasswordUrl": "https://customercenter.marketwatch.com/account#password?mod=ql"
    },
    "marktplaats.nl": {
      "changePasswordUrl": "https://www.marktplaats.nl/account/password-reset/confirm.html"
    },
    "marriott.com": {
      "changePasswordUrl": "https://www.marriott.com/loyalty/myAccount/profile.mi?editChangePassword=true"
    },
    "mathworks.com": {
      "changePasswordUrl": "https://mathworks.com/mwaccount/profiles/password/change"
    },
    "maxpreps.com": {
      "changePasswordUrl": "https://secure.maxpreps.com/utility/member/forgotpassword.aspx"
    },
    "me-qr.com": {
      "changePasswordUrl": "https://admin.me-qr.com/profile"
    },
    "mediafire.com": {
      "changePasswordUrl": "https://www.mediafire.com/myaccount/accountbilling.php#change-pwd-block"
    },
    "mediamarkt.de": {
      "changePasswordUrl": "https://www.mediamarkt.de/de/myaccount/profile"
    },
    "meliuz.com.br": {
      "changePasswordUrl": "https://www.meliuz.com.br/minha-conta/meus-dados/senha"
    },
    "menards.com": {
      "changePasswordUrl": "https://www.menards.com/main/accountoverview.html"
    },
    "mercadolivre.com.br": {
      "changePasswordUrl": "https://www.mercadolivre.com.br/security/password"
    },
    "mercari.com": {
      "changePasswordUrl": "https://www.mercari.com/mypage/email_password/"
    },
    "merkur.de": {
      "changePasswordUrl": "https://accounts.user.id/account/data/personal/password"
    },
    "merriam-webster.com": {
      "changePasswordUrl": "https://www.merriam-webster.com/settings"
    },
    "messagebird.com": {
      "changePasswordUrl": "https://dashboard.messagebird.com/account/security"
    },
    "messenger.com": {
      "changePasswordUrl": "https://www.facebook.com/settings?tab=security"
    },
    "mi.com": {
      "changePasswordUrl": "https://account.xiaomi.com/fe/service/account/?_service=setPassword"
    },
    "michaels.com": {
      "changePasswordUrl": "https://www.michaels.com/buyertools/account-settings"
    },
    "microsoft.com": {
      "changePasswordUrl": "https://account.live.com/password/Change"
    },
    "mlb.com": {
      "changePasswordUrl": "https://www.mlb.com/account/general"
    },
    "mobile.de": {
      "changePasswordUrl": "https://www.mobile.de/meinmobile/bearbeiten"
    },
    "mountainwarehouse.com": {
      "changePasswordUrl": "https://www.mountainwarehouse.com/account/details-link/"
    },
    "msn.com": {
      "changePasswordUrl": "https://account.live.com/password/change?refd=account.microsoft.com&fref=home.banner.changepwd"
    },
    "mundodeportivo.com": {
      "changePasswordUrl": "https://www.mundodeportivo.com/perfil/ev/profile"
    },
    "music.youtube.com": {
      "changePasswordUrl": "https://myaccount.google.com/signinoptions/password"
    },
    "my.goabode.com": {
      "changePasswordUrl": "https://my.goabode.com/#/app/account"
    },
    "myaccount.ea.com": {
      "changePasswordUrl": "https://myaccount.ea.com/cp-ui/security/index"
    },
    "myaccount.google.com": {
      "changePasswordUrl": "https://myaccount.google.com/signinoptions/password"
    },
    "myfreecams.com": {
      "changePasswordUrl": "https://www.myfreecams.com/php/account.php?request=status&vcc=1674246522#change_password"
    },
    "mypay.dfas.mil": {
      "changePasswordUrl": "https://mypay.dfas.mil/#/settings/password"
    },
    "myshopify.com": {
      "changePasswordUrl": "https://accounts.shopify.com/lookup"
    },
    "myspace.com": {
      "changePasswordUrl": "https://myspace.com/settings/profile/email"
    },
    "namecheap.com": {
      "changePasswordUrl": "https://ap.www.namecheap.com/settings/security"
    },
    "native-instruments.com": {
      "changePasswordUrl": "https://www.native-instruments.com/account/settings/"
    },
    "naver.com": {
      "changePasswordUrl": "https://nid.naver.com/user2/help/myInfo.nhn?m=viewChangePasswd"
    },
    "nba.com": {
      "changePasswordUrl": "https://www.nba.com/account/nbaprofile"
    },
    "nbcnews.com": {
      "changePasswordUrl": "https://nbcuniversal.nbc.com/request-password"
    },
    "ncl.com": {
      "changePasswordUrl": "https://www.ncl.com/shorex/update-profile"
    },
    "nekochat.cn": {
      "changePasswordUrl": "https://user.candyrect.com/helpcenter/"
    },
    "nespresso.com": {
      "changePasswordUrl": "https://www.nespresso.com/us/en/myaccount/editPersonalInformations"
    },
    "netflix.com": {
      "changePasswordUrl": "https://www.netflix.com/password"
    },
    "netkeiba.com": {
      "changePasswordUrl": "https://regist.netkeiba.com/?pid=change_passwd"
    },
    "netvibes.com": {
      "changePasswordUrl": "https://www.netvibes.com/account/password"
    },
    "news.google.com": {
      "changePasswordUrl": "https://myaccount.google.com/signinoptions/password"
    },
    "news.yahoo.com": {
      "changePasswordUrl": "https://login.yahoo.com/myaccount/security/change-password/"
    },
    "news.ycombinator.com": {
      "changePasswordUrl": "https://news.ycombinator.com/changepw"
    },
    "newsapi.org": {
      "changePasswordUrl": "https://newsapi.org/account/change-password"
    },
    "newsweek.com": {
      "changePasswordUrl": "https://www.newsweek.com/contact"
    },
    "next.co.uk": {
      "changePasswordUrl": "https://www.next.co.uk/secure/account/MyAccount/UpdateSignInDetails"
    },
    "nextdns.io": {
      "changePasswordUrl": "https://my.nextdns.io/account"
    },
    "nextdoor.com": {
      "changePasswordUrl": "https://nextdoor.com/change_password/"
    },
    "nfl.com": {
      "changePasswordUrl": "https://id.nfl.com/account/change-password"
    },
    "nhentai.net": {
      "changePasswordUrl": "https://nhentai.net/reset/"
    },
    "nicovideo.jp": {
      "changePasswordUrl": "https://account.nicovideo.jp/my/password"
    },
    "nike.com": {
      "changePasswordUrl": "https://www.nike.com/member/settings"
    },
    "nintendo.com": {
      "changePasswordUrl": "https://accounts.nintendo.com/password/edit"
    },
    "njal.la": {
      "changePasswordUrl": "https://njal.la/settings"
    },
    "nordstrom.com": {
      "changePasswordUrl": "https://www.nordstrom.com/my-account/sign-in-info"
    },
    "nordstromrack.com": {
      "changePasswordUrl": "https://www.nordstromrack.com/my-account/sign-in-info"
    },
    "norton.com": {
      "changePasswordUrl": "https://my.norton.com/extspa/account/personalinfo"
    },
    "npo.nl": {
      "changePasswordUrl": "https://id.npo.nl/account/change-password"
    },
    "npr.org": {
      "changePasswordUrl": "https://secure.npr.org/oauth2/login"
    },
    "nvidia.com": {
      "changePasswordUrl": "https://profile.nvgs.nvidia.com/security/change-password"
    },
    "nypost.com": {
      "changePasswordUrl": "https://nypost.com/account/settings"
    },
    "nytimes.com": {
      "changePasswordUrl": "https://www.nytimes.com/account/change-password"
    },
    "office.com": {
      "changePasswordUrl": "https://account.live.com/password/change?refd=account.microsoft.com&fref=home.banner.changepwd"
    },
    "office365.com": {
      "changePasswordUrl": "https://account.live.com/password/change?refd=account.microsoft.com&fref=home.banner.changepwd"
    },
    "officedepot.com": {
      "changePasswordUrl": "https://www.officedepot.com/account/editLoginDisplay.do"
    },
    "okta.com": {
      "changePasswordUrl": "https://my.okta.com/signin/password-reset"
    },
    "onelink.me": {
      "changePasswordUrl": "https://hq1.appsflyer.com/account/change-password"
    },
    "onelink.to": {
      "changePasswordUrl": "https://www.onelink.to/account/settings/security"
    },
    "onlyfans.com": {
      "changePasswordUrl": "https://onlyfans.com/my/settings/account/password"
    },
    "opentable.com": {
      "changePasswordUrl": "https://support.opentable.com/s/login/ForgotPassword?language=en_US"
    },
    "opera.com": {
      "changePasswordUrl": "https://auth.opera.com/account/edit-profile"
    },
    "orcid.org": {
      "changePasswordUrl": "https://orcid.org/account"
    },
    "otto.de": {
      "changePasswordUrl": "https://www.otto.de/customer-identity/changePassword"
    },
    "overleaf.com": {
      "changePasswordUrl": "https://www.overleaf.com/user/settings"
    },
    "overstock.com": {
      "changePasswordUrl": "https://www.overstock.com/myaccount/account/email-password"
    },
    "padlet.com": {
      "changePasswordUrl": "https://padlet.com/dashboard/settings/password"
    },
    "pandora.com": {
      "changePasswordUrl": "https://www.pandora.com/settings/info"
    },
    "paramountplus.com": {
      "changePasswordUrl": "https://www.paramountplus.com/account/"
    },
    "patreon.com": {
      "changePasswordUrl": "https://www.patreon.com/settings/account"
    },
    "paypal.com": {
      "changePasswordUrl": "https://www.paypal.com/myaccount/security/password/change"
    },
    "pch.com": {
      "changePasswordUrl": "https://accounts.pch.com/forgotpass"
    },
    "peacocktv.com": {
      "changePasswordUrl": "https://www.peacocktv.com/forgot"
    },
    "pilotflyingj.com": {
      "changePasswordUrl": "https://portal.pilotflyingj.com/myrewards/forgot-password"
    },
    "pinterest.com": {
      "changePasswordUrl": "https://www.pinterest.com/settings/account-settings"
    },
    "pixieset.com": {
      "changePasswordUrl": "https://gallery.pixieset.com/account/"
    },
    "pl.canalplus.com": {
      "changePasswordUrl": "https://logowanie.pl.canalplus.com/zmien-haslo"
    },
    "playstation.com": {
      "changePasswordUrl": "https://id.sonyentertainmentnetwork.com/id/management/#/p/security"
    },
    "plex.tv": {
      "changePasswordUrl": "https://app.plex.tv/desktop#!/account"
    },
    "pogo.com": {
      "changePasswordUrl": "https://myaccount.ea.com/cp-ui/security/index"
    },
    "politico.com": {
      "changePasswordUrl": "https://www.politico.com/settings"
    },
    "pornhub.com": {
      "changePasswordUrl": "https://www.pornhub.com/user/security"
    },
    "portal.edd.ca.gov": {
      "changePasswordUrl": "https://portal.edd.ca.gov/WebApp/Profile/UpdatePassword"
    },
    "portlandgeneral.com": {
      "changePasswordUrl": "https://portlandgeneral.com/secure/profile/change-password"
    },
    "poshmark.com": {
      "changePasswordUrl": "https://poshmark.com/user/account-info"
    },
    "potterybarn.com": {
      "changePasswordUrl": "https://www.potterybarn.com/account/updatepassword.html"
    },
    "ppomppu.co.kr": {
      "changePasswordUrl": "https://www.ppomppu.co.kr/myinfo/profile.php"
    },
    "priceline.com": {
      "changePasswordUrl": "https://www.priceline.com/next-profile/profile?tab=sign_in_info"
    },
    "prolific.co": {
      "changePasswordUrl": "https://app.prolific.co/account/general"
    },
    "proton.me": {
      "changePasswordUrl": "https://account.proton.me/u/0/vpn/account-password"
    },
    "prowlapp.com": {
      "changePasswordUrl": "https://www.prowlapp.com/settings.php"
    },
    "quince.com": {
      "changePasswordUrl": "https://www.quince.com/account/my-profile"
    },
    "quizlet.com": {
      "changePasswordUrl": "https://quizlet.com/settings"
    },
    "quora.com": {
      "changePasswordUrl": "https://www.quora.com/settings"
    },
    "qvc.com": {
      "changePasswordUrl": "https://www.qvc.com/myaccount/reg/account-settings.html"
    },
    "rakuten.co.jp": {
      "changePasswordUrl": "https://profile.id.rakuten.co.jp/account-security"
    },
    "rakuten.com": {
      "changePasswordUrl": "https://www.rakuten.com/account-settings.htm"
    },
    "readymag.com": {
      "changePasswordUrl": "https://auth.readymag.com/password/forgot"
    },
    "realtor.com": {
      "changePasswordUrl": "https://www.realtor.com/myaccount/profile/settings"
    },
    "redd.it": {
      "changePasswordUrl": "https://www.reddit.com/settings/"
    },
    "reddit.com": {
      "changePasswordUrl": "https://www.reddit.com/settings/"
    },
    "redfin.com": {
      "changePasswordUrl": "https://www.redfin.com/change-password"
    },
    "redgifs.com": {
      "changePasswordUrl": "https://auth.redgifs.com/lo/reset?ticket="
    },
    "redirect.pizza": {
      "changePasswordUrl": "https://redirect.pizza/profile"
    },
    "redtube.com": {
      "changePasswordUrl": "https://www.redtube.com/settings"
    },
    "reelgood.com": {
      "changePasswordUrl": "https://reelgood.com/account"
    },
    "rei.com": {
      "changePasswordUrl": "https://www.rei.com/YourAccountCredentials"
    },
    "rejsekort.dk": {
      "changePasswordUrl": "https://selvbetjening.rejsekort.dk/CWS/CustomerManagement/ChangePassword"
    },
    "rentcafe.com": {
      "changePasswordUrl": "https://www.rentcafe.com/onlineleasing/apartmentsforrent/myaccount/changepassword.aspx"
    },
    "reuters.com": {
      "changePasswordUrl": "https://www.reuters.com/account/forgot-password/"
    },
    "revolve.com": {
      "changePasswordUrl": "https://www.revolve.com/r/MyAccountSettings.jsp"
    },
    "rightmove.co.uk": {
      "changePasswordUrl": "https://www.rightmove.co.uk/user/accountsettings.html"
    },
    "ring.com": {
      "changePasswordUrl": "https://account.ring.com/account/control-center/account-management"
    },
    "riotgames.com": {
      "changePasswordUrl": "https://account.riotgames.com/"
    },
    "robinhood.com": {
      "changePasswordUrl": "https://robinhood.com/account/settings/security"
    },
    "roblox.com": {
      "changePasswordUrl": "https://www.roblox.com/my/account#!/info"
    },
    "rottentomatoes.com": {
      "changePasswordUrl": "https://www.rottentomatoes.com/user/account"
    },
    "royalcaribbean.com": {
      "changePasswordUrl": "https://www.royalcaribbean.com/myaccount/settings/sign-in-information"
    },
    "ruc.dk": {
      "changePasswordUrl": "https://pwrecovery.ruc.dk"
    },
    "rule34.xxx": {
      "changePasswordUrl": "https://rule34.xxx/index.php?page=account&s=change_password"
    },
    "rumble.com": {
      "changePasswordUrl": "https://rumble.com/account/profile"
    },
    "safeco.com": {
      "changePasswordUrl": "https://customer.safeco.com/accountmanager/profile/changepassword"
    },
    "safeway.com": {
      "changePasswordUrl": "https://www.safeway.com/customer-account/account-settings"
    },
    "saksfifthavenue.com": {
      "changePasswordUrl": "https://www.saksfifthavenue.com/account/edit-password"
    },
    "samsclub.com": {
      "changePasswordUrl": "https://www.samsclub.com/account/personal-info?xid=hdr_account_change-password"
    },
    "samsung.com": {
      "changePasswordUrl": "https://account.samsung.com/membership/contents/security/password/change-password"
    },
    "santahelenasaude.com.br": {
      "changePasswordUrl": "https://www.santahelenasaude.com.br/beneficiario/#/alterar-senha"
    },
    "saturn.de": {
      "changePasswordUrl": "https://www.saturn.de/webapp/wcs/stores/servlet/MultiChannelMAChangePassword"
    },
    "scribd.com": {
      "changePasswordUrl": "https://www.scribd.com/account-settings#change-password"
    },
    "secondlife.com": {
      "changePasswordUrl": "https://accounts.secondlife.com/change_password"
    },
    "secure.orclinic.com": {
      "changePasswordUrl": "https://secure.orclinic.com/portal/editprofile.aspx"
    },
    "sephora.com": {
      "changePasswordUrl": "https://www.sephora.com/profile/MyAccount"
    },
    "serasa.com.br": {
      "changePasswordUrl": "https://www.serasa.com.br/meus-dados/alterar-senha"
    },
    "service-now.com": {
      "changePasswordUrl": "https://profile.servicenow.com/now/cuam/user-profile-detail/myProfile/SN"
    },
    "shein.com": {
      "changePasswordUrl": "https://shein.com/user/security"
    },
    "shodan.io": {
      "changePasswordUrl": "https://account.shodan.io/change_password"
    },
    "shoop.de": {
      "changePasswordUrl": "https://www.shoop.de/einstellungen/benutzerdaten"
    },
    "shopback.co.kr": {
      "changePasswordUrl": "https://www.shopback.co.kr/account/change-password"
    },
    "shopify.com": {
      "changePasswordUrl": "https://accounts.shopify.com/lookup"
    },
    "shutterfly.com": {
      "changePasswordUrl": "https://accounts.shutterfly.com/account-settings"
    },
    "shutterstock.com": {
      "changePasswordUrl": "https://accounts.shutterstock.com/credentials/change"
    },
    "signupgenius.com": {
      "changePasswordUrl": "https://www.signupgenius.com/index.cfm?go=c.ResetPW"
    },
    "singaporeair.com": {
      "changePasswordUrl": "https://www.singaporeair.com/krisflyer/profile/security"
    },
    "sipgatebasic.de": {
      "changePasswordUrl": "https://app.sipgatebasic.de/settings"
    },
    "slickdeals.net": {
      "changePasswordUrl": "https://slickdeals.net/forums/login.php?do=lostpw"
    },
    "smugmug.com": {
      "changePasswordUrl": "https://www.smugmug.com/app/profile"
    },
    "snapchat.com": {
      "changePasswordUrl": "https://accounts.snapchat.com/accounts/change_password"
    },
    "sncf-connect.com": {
      "changePasswordUrl": "https://www.sncf-connect.com/account/personal-info"
    },
    "soap2day.to": {
      "changePasswordUrl": "https://soap2day.to/home/user/changepassword"
    },
    "solitaired.com": {
      "changePasswordUrl": "https://solitaired.com/user/reset-password?"
    },
    "sonos.com": {
      "changePasswordUrl": "https://www.sonos.com/myaccount/user/profile/"
    },
    "sony.com": {
      "changePasswordUrl": "https://id.sonyentertainmentnetwork.com/id/management/#/p/security"
    },
    "sonyentertainmentnetwork.com": {
      "changePasswordUrl": "https://id.sonyentertainmentnetwork.com/id/management/#/p/security"
    },
    "soundcloud.com": {
      "changePasswordUrl": "https://soundcloud.com/settings"
    },
    "southwest.com": {
      "changePasswordUrl": "https://www.southwest.com/loyalty/myaccount/profile-security.html"
    },
    "spankbang.com": {
      "changePasswordUrl": "https://spankbang.com/users/account"
    },
    "spectrum.net": {
      "changePasswordUrl": "https://www.spectrum.net/user-preferences/your-info/manage/security"
    },
    "speedway.com": {
      "changePasswordUrl": "https://www.speedway.com/my-account/security/passcode"
    },
    "spiegel.de": {
      "changePasswordUrl": "https://gruppenkonto.spiegel.de/meinkonto/accountdaten/passwortaendern.html"
    },
    "splitwise.com": {
      "changePasswordUrl": "https://secure.splitwise.com/account/settings"
    },
    "splunk.com": {
      "changePasswordUrl": "https://www.splunk.com/my-account/#/profile-details"
    },
    "sports.yahoo.com": {
      "changePasswordUrl": "https://login.yahoo.com/account/change-password"
    },
    "spotify.com": {
      "changePasswordUrl": "https://www.spotify.com/in-en/account/change-password/"
    },
    "squarespace.com": {
      "changePasswordUrl": "https://account.squarespace.com/settings/security/password"
    },
    "squareup.com": {
      "changePasswordUrl": "https://app.squareup.com/dashboard/account"
    },
    "ssa.gov": {
      "changePasswordUrl": "https://secure.ssa.gov/RIM/UpwdView.action"
    },
    "stackoverflow.com": {
      "changePasswordUrl": "https://stackoverflow.com/users/account-recovery"
    },
    "stacksocial.com": {
      "changePasswordUrl": "https://stacksocial.com/user?show=account-tab"
    },
    "starbucks.com": {
      "changePasswordUrl": "https://www.starbucks.com/account/settings/password"
    },
    "state.nj.us": {
      "changePasswordUrl": "https://my.state.nj.us/edituser/EditUserProfile"
    },
    "steamcommunity.com": {
      "changePasswordUrl": "https://help.steampowered.com/en/wizard/HelpChangePassword?redir=store/account/"
    },
    "steampowered.com": {
      "changePasswordUrl": "https://help.steampowered.com/en/wizard/HelpChangePassword?redir=store/account/"
    },
    "stonly.com": {
      "changePasswordUrl": "https://app.stonly.com/app/general/userSettings/Account"
    },
    "stripchat.com": {
      "changePasswordUrl": "https://stripchat.com/settings"
    },
    "stubhub.com": {
      "changePasswordUrl": "https://my.stubhub.com/settings?activeTab=PERSONALDETAILS"
    },
    "sulamericaseguros.com.br": {
      "changePasswordUrl": "https://saude.sulamericaseguros.com.br/segurado/gerenciar-cadastro/"
    },
    "surveymonkey.com": {
      "changePasswordUrl": "https://identity.surveymonkey.com/us/manage?locale=en"
    },
    "suumo.jp": {
      "changePasswordUrl": "https://point.recruit.co.jp/member/passwdChg/"
    },
    "swagbucks.com": {
      "changePasswordUrl": "https://www.swagbucks.com/account/settings"
    },
    "swarmapp.com": {
      "changePasswordUrl": "https://foursquare.com/change_password"
    },
    "swinglifestyle.com": {
      "changePasswordUrl": "https://www.swinglifestyle.com/profile/"
    },
    "syf.com": {
      "changePasswordUrl": "https://mastercard.syf.com/login/reset"
    },
    "synchrony.com": {
      "changePasswordUrl": "https://consumercenter.mysynchrony.com/consumercenter/"
    },
    "syosetu.org": {
      "changePasswordUrl": "https://syosetu.org/?mode=user_info_edit"
    },
    "tagged.com": {
      "changePasswordUrl": "https://secure.tagged.com/account_info.html?dataSource=Settings&ll=nav"
    },
    "talbots.com": {
      "changePasswordUrl": "https://www.talbots.com/profile"
    },
    "target.com": {
      "changePasswordUrl": "https://logonservices.iam.target.com/change-password/?target=#!"
    },
    "tasteofhome.com": {
      "changePasswordUrl": "https://www.tasteofhome.com/login/updatepassword"
    },
    "teacherspayteachers.com": {
      "changePasswordUrl": "https://www.teacherspayteachers.com/My-Account/Basics/edit"
    },
    "teamviewer.com": {
      "changePasswordUrl": "https://login.teamviewer.com/nav/profile/change-password"
    },
    "telekom.de": {
      "changePasswordUrl": "https://account.idm.telekom.com/account-manager/password/index.xhtml"
    },
    "temu.com": {
      "changePasswordUrl": "https://www.temu.com/bgp_account_security.html"
    },
    "tesla.com": {
      "changePasswordUrl": "https://accounts.tesla.com/account-settings/security"
    },
    "the-sun.com": {
      "changePasswordUrl": "https://home.thesun.co.uk/edit/password"
    },
    "theguardian.com": {
      "changePasswordUrl": "https://profile.theguardian.com/reset"
    },
    "thejigsawpuzzles.com": {
      "changePasswordUrl": "https://thejigsawpuzzles.com/profile/?changepassword"
    },
    "theknot.com": {
      "changePasswordUrl": "https://www.theknot.com/account/settings/"
    },
    "thenounproject.com": {
      "changePasswordUrl": "https://thenounproject.com/accounts/password/change/"
    },
    "thesimsresource.com": {
      "changePasswordUrl": "https://www.thesimsresource.com/account#/account"
    },
    "thesun.co.uk": {
      "changePasswordUrl": "https://login.thesun.co.uk/user/changePassword"
    },
    "thetrainline.com": {
      "changePasswordUrl": "https://www.thetrainline.com/my-account/change-password"
    },
    "thetvdb.com": {
      "changePasswordUrl": "https://www.thetvdb.com/dashboard/account/changepass"
    },
    "ti.com": {
      "changePasswordUrl": "https://login.ti.com/ext/pwdchange/Identify"
    },
    "ticketmaster.com": {
      "changePasswordUrl": "https://my.ticketmaster.com/security"
    },
    "tiktok.com": {
      "changePasswordUrl": "https://www.tiktok.com/login/email/forget-password"
    },
    "time.com": {
      "changePasswordUrl": "https://time.com/manage-account/"
    },
    "tinyurl.com": {
      "changePasswordUrl": "https://tinyurl.com/app/settings/security"
    },
    "tmon.co.kr": {
      "changePasswordUrl": "https://login.tmon.co.kr/user/info"
    },
    "tmz.com": {
      "changePasswordUrl": "https://shop.tmz.com/user?show=account-tab"
    },
    "todoist.com": {
      "changePasswordUrl": "https://app.todoist.com/app/settings/account"
    },
    "trakt.tv": {
      "changePasswordUrl": "https://trakt.tv/settings#password"
    },
    "trip.com": {
      "changePasswordUrl": "https://www.trip.com/membersinfo/profile/"
    },
    "tripadvisor.com": {
      "changePasswordUrl": "https://www.tripadvisor.com/Settings-cp"
    },
    "tripit.com": {
      "changePasswordUrl": "https://tripit.com/account/edit/section/change_password"
    },
    "trulia.com": {
      "changePasswordUrl": "https://www.trulia.com/account/user_profile"
    },
    "tudogostoso.com.br": {
      "changePasswordUrl": "https://profile.tudogostoso.com.br/editar_perfil.htm"
    },
    "tum.de": {
      "changePasswordUrl": "https://campus.tum.de"
    },
    "tumblr.com": {
      "changePasswordUrl": "https://www.tumblr.com/settings/account"
    },
    "turkishairlines.com": {
      "changePasswordUrl": "https://www.turkishairlines.com/tr-int/miles-and-smiles/forgot-password/"
    },
    "tv2.dk": {
      "changePasswordUrl": "https://mit.tv2.dk/konto/skift-adgangskode"
    },
    "tver.jp": {
      "changePasswordUrl": "https://id.tver.jp/mypage/password/edit"
    },
    "twilio.com": {
      "changePasswordUrl": "https://www.twilio.com/console/user/settings"
    },
    "twitch.tv": {
      "changePasswordUrl": "https://www.twitch.tv/settings/security"
    },
    "twitter.com": {
      "changePasswordUrl": "https://twitter.com/settings/password"
    },
    "uber.com": {
      "changePasswordUrl": "https://account.uber.com/workflow?workflow=PASSWORD&workflow_next_url=BACK"
    },
    "udacity.com": {
      "changePasswordUrl": "https://classroom.udacity.com/settings/password"
    },
    "udel.edu": {
      "changePasswordUrl": "https://udapps.nss.udel.edu/myUDsettings/password"
    },
    "ugg.com": {
      "changePasswordUrl": "https://www.ugg.com/password/edit"
    },
    "uline.com": {
      "changePasswordUrl": "https://www.uline.com/MyAccount/ContactPref"
    },
    "ulta.com": {
      "changePasswordUrl": "https://www.ulta.com/account/manage"
    },
    "uml.edu": {
      "changePasswordUrl": "https://mypassword.uml.edu/#Change"
    },
    "umsystem.edu": {
      "changePasswordUrl": "https://password.umsystem.edu/reset/"
    },
    "united.com": {
      "changePasswordUrl": "https://www.united.com/ual/en/US/account/security/setpassword"
    },
    "ups.com": {
      "changePasswordUrl": "https://www.ups.com/lasso/login"
    },
    "usaa.com": {
      "changePasswordUrl": "https://www.usaa.com/inet/ent_auth_password/pages/ChangePasswordPage"
    },
    "usatoday.com": {
      "changePasswordUrl": "https://login.usatoday.com/USAT-GUP-SAM/password-change/"
    },
    "uscis.gov": {
      "changePasswordUrl": "https://myaccount.uscis.gov/users/registration/password"
    },
    "usnews.com": {
      "changePasswordUrl": "https://auth.usnews.com/changePassword"
    },
    "usps.com": {
      "changePasswordUrl": "https://reg.usps.com/entreg/secure/ChangePasswordAction_input?returnActionName"
    },
    "vagaro.com": {
      "changePasswordUrl": "https://www.vagaro.com/myaccount/profile"
    },
    "vanguard.com": {
      "changePasswordUrl": "https://security-settings.web.vanguard.com/username-password"
    },
    "vccs.edu": {
      "changePasswordUrl": "https://www.apply.vccs.edu/Profile/_default.aspx"
    },
    "venmo.com": {
      "changePasswordUrl": "https://account.venmo.com/settings/profile/change-password"
    },
    "ventrachicago.com": {
      "changePasswordUrl": "https://www.ventrachicago.com/account/manage-account/"
    },
    "verizon.com": {
      "changePasswordUrl": "https://myvpostpay.verizon.com/ui/bill/secure/"
    },
    "viator.com": {
      "changePasswordUrl": "https://www.viator.com/account/myProfile?tab=login"
    },
    "victoriassecret.com": {
      "changePasswordUrl": "https://www.victoriassecret.com/us/account/profile#changePassword"
    },
    "vimeo.com": {
      "changePasswordUrl": "https://vimeo.com/settings/account/password"
    },
    "vinted.fr": {
      "changePasswordUrl": "https://www.vinted.fr/member/general/change_password"
    },
    "virginmobile.ca": {
      "changePasswordUrl": "https://myaccount.virginmobile.ca/MyProfile/Details/EditProfile?editField=PASSWORD"
    },
    "vivo.com.br": {
      "changePasswordUrl": "https://meuvivo.vivo.com.br/meuvivo/appmanager/portal/fixo"
    },
    "vrbo.com": {
      "changePasswordUrl": "https://www.vrbo.com/traveler/profile/edit"
    },
    "vsco.co": {
      "changePasswordUrl": "https://vsco.co/user/account"
    },
    "walgreens.com": {
      "changePasswordUrl": "https://www.walgreens.com/account/user_and_password"
    },
    "walmart.com": {
      "changePasswordUrl": "https://www.walmart.com/account/profile"
    },
    "washingtonpost.com": {
      "changePasswordUrl": "https://www.washingtonpost.com/my-post/account/password/"
    },
    "wattpad.com": {
      "changePasswordUrl": "https://www.wattpad.com/settings"
    },
    "wayfair.com": {
      "changePasswordUrl": "https://www.wayfair.com/v/account/personal_info/edit"
    },
    "wealthsimple.com": {
      "changePasswordUrl": "https://my.wealthsimple.com/app/settings/security"
    },
    "weather.com": {
      "changePasswordUrl": "https://weather.com/member/settings"
    },
    "webmd.com": {
      "changePasswordUrl": "https://member.webmd.com/password-reset"
    },
    "welt.de": {
      "changePasswordUrl": "https://signin.auth.welt.de/change-password"
    },
    "weverse.io": {
      "changePasswordUrl": "https://account.weverse.io/en/my-page"
    },
    "wii-homebrew.com": {
      "changePasswordUrl": "https://forum.wii-homebrew.com/index.php/AccountManagement/"
    },
    "wikihow.com": {
      "changePasswordUrl": "https://www.wikihow.com/Special:ChangeCredentials/MediaWiki%5CAuth%5CPasswordAuthenticationRequest"
    },
    "wikimedia.org": {
      "changePasswordUrl": "https://auth.wikimedia.org/enwiki/wiki/Special:ChangeCredentials"
    },
    "wikipedia.org": {
      "changePasswordUrl": "https://en.wikipedia.org/w/index.php?title=Special:ChangeCredentials/MediaWiki%5CAuth%5CPasswordAuthenticationRequest&returnto=Special%3APreferences"
    },
    "wired.com": {
      "changePasswordUrl": "https://www.wired.com/account/reset-password"
    },
    "wise.com": {
      "changePasswordUrl": "https://wise.com/your-account/security-and-privacy/change-password"
    },
    "wordpress.com": {
      "changePasswordUrl": "https://wordpress.com/me/security/password"
    },
    "wordwall.net": {
      "changePasswordUrl": "https://wordwall.net/account/changepassword"
    },
    "worldstar.com": {
      "changePasswordUrl": "https://worldstarhiphop.com/videos/reset.php"
    },
    "worldwinner.com": {
      "changePasswordUrl": "https://www.worldwinner.com/cgi/finance/account.pl"
    },
    "wsj.com": {
      "changePasswordUrl": "https://customercenter.wsj.com/account#password"
    },
    "wunderground.com": {
      "changePasswordUrl": "https://www.wunderground.com/member/settings"
    },
    "x.com": {
      "changePasswordUrl": "https://x.com/settings/password"
    },
    "xero.com": {
      "changePasswordUrl": "https://identity.xero.com/account/?AccountUrl=/!xkcD/Settings/MyAccount"
    },
    "xfinity.com": {
      "changePasswordUrl": "https://customer.xfinity.com/users/me/update-password"
    },
    "xhamster.com": {
      "changePasswordUrl": "https://xhamster.com/password-recovery"
    },
    "xiaomi.com": {
      "changePasswordUrl": "https://account.xiaomi.com/fe/service/account/?_service=setPassword"
    },
    "xvideos.com": {
      "changePasswordUrl": "https://www.xvideos.com/account/security"
    },
    "yahoo.com": {
      "changePasswordUrl": "https://login.yahoo.com/account/change-password"
    },
    "yellowpages.com": {
      "changePasswordUrl": "https://www.yellowpages.com/settings/password"
    },
    "yelp.com": {
      "changePasswordUrl": "https://yelp.com/profile_password"
    },
    "youporn.com": {
      "changePasswordUrl": "https://www.youporn.com/settings/change/password/"
    },
    "youtube.com": {
      "changePasswordUrl": "https://myaccount.google.com/signinoptions/password"
    },
    "zappos.com": {
      "changePasswordUrl": "https://www.zappos.com/account/password"
    },
    "zazzle.com": {
      "changePasswordUrl": "https://www.zazzle.com/my/account/password"
    },
    "zeit.de": {
      "changePasswordUrl": "https://meine.zeit.de/passwortaendern"
    },
    "zeplin.io": {
      "changePasswordUrl": "https://app.zeplin.io/profile/password"
    },
    "zhihu.com": {
      "changePasswordUrl": "https://www.zhihu.com/settings/account"
    },
    "zillow.com": {
      "changePasswordUrl": "https://www.zillow.com/myzillow/profile/"
    },
    "ziprecruiter.com": {
      "changePasswordUrl": "https://www.ziprecruiter.com/login/forgot-password?realm=candidates"
    },
    "zocdoc.com": {
      "changePasswordUrl": "https://www.zocdoc.com/patient/editprofile?section=Password"
    },
    "zola.com": {
      "changePasswordUrl": "https://www.zola.com/account/settings/password-security"
    },
    "zoom.us": {
      "changePasswordUrl": "https://zoom.us/profile"
    },
    "zulily.com": {
      "changePasswordUrl": "https://www.zulily.com/account/edit?rel=top_flyout"
    }
  },
  "pspAdapters": [
    {
      "psp": "gr4vy",
      "origin": "https://secure-fields.*.gr4vy.app",
      "role": {
        "byQueryParam": "type",
        "map": {
          "number": "number",
          "expiryDate": "exp",
          "securityCode": "cvv"
        }
      }
    },
    {
      "psp": "stripe",
      "origin": "https://js.stripe.com",
      "role": {
        "byFrameTitle": {
          "card number": "number",
          "expiration": "exp",
          "cvc": "cvv",
          "card payment": "number",
          "payment input": "number"
        }
      }
    },
    {
      "psp": "braintree",
      "origin": "https://assets.braintreegateway.com",
      "role": {
        "byFrameName": {
          "cvv": "cvv",
          "expiration": "exp",
          "number": "number"
        }
      }
    },
    {
      "psp": "shopify",
      "origin": "https://checkout.pci.shopifyinc.com",
      "role": {
        "byFrameName": {
          "verification_value": "cvv",
          "expiry": "exp",
          "number": "number"
        }
      }
    }
  ]
};
